'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const PerfectScrollbar=require('perfect-scrollbar');
const BaseDirective=require('../../../../dist-es6/client/angularCommon/baseDirective');

const Options=[
'wheelSpeed','wheelPropagation','minScrollbarLength','maxScrollbarLength',
'useBothWheelAxes','useKeyboard','suppressScrollX','suppressScrollY',
'scrollXMarginOffset','scrollYMarginOffset','includePadding'];let


ScrollbarDirective=function(_BaseDirective){_inherits(ScrollbarDirective,_BaseDirective);function ScrollbarDirective(){_classCallCheck(this,ScrollbarDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}ScrollbarDirective.prototype.
















factory=function factory($parse,$window,$timeout,sidebarScrollingService){
const directive=_BaseDirective.prototype.factory.call(this);
const _window=angular.element($window);

directive.transclude=!0;
directive.replace=!0;

directive.link=function($scope,$element,$attr){
if($scope.useSidebarService){
$scope.$on('$destroy',function(){
sidebarScrollingService.reset();
});
}

const _element=$element[0];
const options={};
let _scrollbar;


Options.filter(function(opt){return _.exists($attr[opt])}).forEach(function(opt){
options[opt]=$parse($attr[opt])();
});

if($scope.useSidebarService){
sidebarScrollingService.preventAutoScroll=!0;
}

let onScrollEventHandler;
$scope.$evalAsync(function(){
if($scope.useSidebarService){
sidebarScrollingService.preventAutoScroll=!1;
sidebarScrollingService.immediatelyJumpToLastPosition();
}
_scrollbar=new PerfectScrollbar(_element,options);

const hasOnScrollHandler=_.exists($scope.onScroll)||_.exists($attr.onScroll)&&$attr.onScroll!=='';
if(!($scope.useSidebarService||hasOnScrollHandler)){
return;
}

const onScrollHandler=hasOnScrollHandler?$parse($scope.onScroll||$attr.onScroll):null;
const processScrollEvent=function(){
fastdom.measure(function(){
let scrollTop=$element.scrollTop();
let scrollHeight=hasOnScrollHandler?$element.prop('scrollHeight')-$element.height():null;
if(hasOnScrollHandler){
onScrollHandler($scope,{scrollTop:scrollTop,scrollHeight:scrollHeight});
}

if($scope.useSidebarService){
sidebarScrollingService.updateLastPosition(scrollTop);
}
});
};

onScrollEventHandler=processScrollEvent;

$element.scroll(onScrollEventHandler);
});

const _scrollTop=function(){return fastdom.mutate(function(){return $($element).scrollTop($($element).prop('scrollHeight'))})};
const _update=function(event){
if(!_scrollbar){
return;
}

if($attr.scrollDown==='true'&&event!=='mouseenter'){
$timeout(_scrollTop,100);
}
_scrollbar.update(_element);
};

const update=function(event){return _update(event)};


$element.bind('mouseenter',function(){return update('mouseenter')});


if($attr.refreshOnChange){
$scope.$watchCollection($attr.refreshOnChange,function(){return update('refreshOnChange')});
}


if($attr.refreshOnResize){
_window.on('resize',update);
}

$element.bind('$destroy',function(){
if($attr.refreshOnResize){
_window.off('resize',update);
}
if(_.exists(onScrollEventHandler)){
$element.off('scroll',onScrollEventHandler);
}
if(_scrollbar){
_scrollbar.destroy(_element);
_scrollbar=null;
}
});
};

return directive;
};_createClass(ScrollbarDirective,[{key:'restrict',get:function(){return'EA'}},{key:'objectBindings',get:function(){return['useSidebarService','onScroll','refreshOnChange']}},{key:'textBindings',get:function(){return Options}},{key:'templateUrl',get:function(){return'/templates/directives/scrollbarDirective/scrollbarTemplate'}}]);return ScrollbarDirective}(BaseDirective);



module.exports=ScrollbarDirective;
module.exports.prototype.factory.$inject=['$parse','$window','$timeout','sidebarScrollingService'];
//# sourceMappingURL=scrollbarDirective.js.map
